import { render } from "./Sidebar.vue?vue&type=template&id=b726b4d2&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=b726b4d2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b726b4d2"

export default script